<template>
  <div>
    <div>
      <el-select
        :value="materialSelect"
        :remote-method="data => handleSearchMaterial('code', data)"
        :disabled="disabled"
        clearable
        filterable
        remote
        style="width: 100%"
        @input="handleChangeMaterialCode($event)"
      >
        <el-option
          v-for="p in materialCodeDropdown"
          :key="p.code"
          :value="p.code"
          :label="p.code_description_unit"
          >{{ p.code_description_unit }}</el-option
        >
      </el-select>
    </div>
    <div
      v-if="isShowCreateMaterialCode"
      class="dialog-bg"
      @click.self="onConfirm(false)"
    >
      <div class="dialog-box">
        <div class="header mb-3">สร้าง Material Code ใหม่</div>
        <div class="row mb-3">
          <div class="col-5">
            <label class="label">Material group</label>
            <el-select
              v-model="materialGroupSelect"
              :remote-method="data => handleSearchMaterial('group', data)"
              class="input"
              clearable
              filterable
              remote
              style="width: 100%"
            >
              <el-option
                v-for="p in materialGroupDropdown"
                :key="p.id"
                :value="p.id"
                :label="p.code_name"
                >{{ p.code_name }}</el-option
              >
            </el-select>
          </div>
          <div class="col-7">
            <label class="label"
              >Material name ({{ meterialName ? meterialName.length : 0 }}/40)</label
            >
            <el-input v-model="meterialName" class="input"></el-input>
          </div>
        </div>
        <div class="row">
          <div class="col-5">
            <label class="label">หน่วยนับของสินค้า/บริการ</label>
            <el-select
              v-model="materialUnitSelect"
              :remote-method="data => handleSearchMaterial('unit', data)"
              class="input"
              clearable
              filterable
              remote
              style="width: 100%"
            >
              <el-option
                v-for="p in materialUnitDropdown"
                :key="p.id"
                :value="p.id"
                :label="p.unit"
                >{{ p.unit }}</el-option
              >
            </el-select>
          </div>
          <div class="col-7 mt-4">
            <label class="select-input">
              <span>ต้องสต็อกสินค้า</span>
              <input
                v-model="isInventoryUpdate"
                :value="true"
                type="radio"
                name="type"
              />
              <span class="checkmark radio"></span>
            </label>
            <label class="select-input">
              <span>ไม่ต้องสต็อกสินค้า</span>
              <input
                v-model="isInventoryUpdate"
                :value="false"
                type="radio"
                name="type"
              />
              <span class="checkmark radio"></span>
            </label>
          </div>
        </div>
        <div class="text-end mt-5">
          <sc-button variant="danger" @click="handleClickCancel"
            >ยกเลิก</sc-button
          >
          <sc-button variant="primary" @click="handleClickSave"
            >บันทึก</sc-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Input, Select, Option } from "element-ui";
import ScButton from "@/lib/components/ScButton";
import { baanRueJaiClient } from "@/dependencies";

export default {
  components: {
    "el-input": Input,
    "el-select": Select,
    "el-option": Option,
    ScButton,
  },
  props: {
    value: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isShowCreateMaterialCode: false,
      materialGroupSelect: null,
      materialUnitSelect: null,
      meterialName: null,
      materialGroupList: [],
      materialGroupChangingDropdown: null,
      materialCodeChangingDropdown: null,
      materialCodeList: [],
      materialUnitList: [],
      materialUnitChangingDropdown: null,
      isInventoryUpdate: false
    };
  },
  computed: {
    materialSelect() {
      return this.value;
    },
    materialGroupDropdown() {
      return this.materialGroupChangingDropdown
        ? this.materialGroupChangingDropdown
        : this.materialGroupList;
    },
    materialCodeDropdown() {
      return this.materialCodeChangingDropdown
        ? this.materialCodeChangingDropdown
        : this.materialCodeList;
    },
    materialUnitDropdown() {
      return this.materialUnitChangingDropdown
        ? this.materialUnitChangingDropdown
        : this.materialUnitList;
    }
  },
  watch: {
    materialGroupSelect() {
      this.materialGroupChangingDropdown = null;
    },
    materialUnitSelect() {
      this.materialUnitChangingDropdown = null;
    },
    meterialName(newValue, oldValue) {
      if (newValue && newValue.length > 40) {
        this.meterialName = oldValue;
      }
    },
    value(newValue) {
      this.findUnitName(newValue);
    }
  },
  created() {
    this.setup();
  },
  methods: {
    async setup() {
      await this.setupMaterialCode();
      await this.setupMaterialGroup();
      await this.setupMaterialUnit();
    },
    async setupMaterialCode() {
      const response = await baanRueJaiClient.admin.sap.codeList();
      const matCodeList = response.data.result.materials;
      const materialArrayForAddMatCode = [{ code: "addMaterialCode", code_description_unit: "+ สร้างใหม่" }];

      this.materialCodeList = materialArrayForAddMatCode.concat(matCodeList);
    },
    async setupMaterialGroup() {
      const response = await baanRueJaiClient.admin.sap.groupList();
      const matGroupList = response.data.result.materials;
      
      this.materialGroupList = matGroupList;
    },
    async setupMaterialUnit() {
      const response = await baanRueJaiClient.admin.sap.unitList();
      const matGroupList = response.data.result.materials;
      
      this.materialUnitList = matGroupList;
    },
    handleChangeMaterialCode(materialCode) {
      if (materialCode === "addMaterialCode") {
        this.isShowCreateMaterialCode = true;
      } else {
        this.$emit("input", materialCode);

        this.materialCodeChangingDropdown = null;
      }
    },
    onConfirm(action) {
      this.$emit("confirm", action);
    },
    async handleClickSave() {
      if (!this.materialGroupSelect) {
        this.$message.error('กรุณาเลือก Material group');

        return
      }

      if (!this.materialUnitSelect) {
        this.$message.error('กรุณาเลือก หน่วยนับของสินค้า/บริการ');
        return
      }

      if (!this.meterialName) {
        this.$message.error('กรุณากรอก Material name');
        return
      }

      try {
        await this.createMaterialCode();
        await this.setupMaterialCode();

        this.$message.success('บันทึกเสร็จสิ้น');
        this.handleClickCancel();
      } catch (err) {
        if (
          err.response
          && err.response.status === 400
          && err.response.data
          && err.response.data.message
        ) {
          this.$message.error(err.response.data.message);
        } else {
          this.$message.error("เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
        }
      }
    },
    async createMaterialCode() {
      const params = {
        group_id: +this.materialGroupSelect,
        unit_id: this.materialUnitSelect,
        name: this.meterialName,
        is_inventory_update: this.isInventoryUpdate
      };

      await baanRueJaiClient.admin.sap.postMaterialCode(params);
    },
    handleClickCancel() {
      this.materialGroupSelect = null;
      this.materialUnitSelect = null;
      this.meterialName = null;

      this.isShowCreateMaterialCode = false;
    },
    handleSearchMaterial(key, value) {
      if (key === "group") {
        this.materialGroupChangingDropdown = this.materialGroupList.filter((item) => item.code_name.toUpperCase().includes(value.toUpperCase()));
      }

      if (key === 'code') {
        this.materialCodeChangingDropdown = this.materialCodeList.filter((item) => item.code_description_unit.toUpperCase().includes(value.toUpperCase()));
      }

      if (key === 'unit') {
        this.materialUnitChangingDropdown = this.materialUnitList.filter((item) => item.unit.toUpperCase().includes(value.toUpperCase()));
      }
    },
    async findUnitName(material) {
      if (!this.materialCodeList || this.materialCodeList.length === 0) {
        this.$emit("unitName", null);
        return
      };

      const materialSelected = this.materialCodeList.find(
        (materialCode) => materialCode.code === material
      );

      if (!materialSelected) {
        this.$emit("unitName", null);
        return
      };

      const materialSelectedSplitString = materialSelected.code_description_unit.split(" ");
      const unitName = materialSelectedSplitString[materialSelectedSplitString.length - 1];

      this.$emit("unitName", { unitName, codeDescriptionUnit: materialSelected.code_description_unit });
    },
  },
};
</script>


<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.label {
  margin-bottom: 5px;
  display: block;

  line-height: 1.6;
  font-size: 1rem;
  font-weight: bold;
}

.dialog-box {
  top: 50%;
  left: 50%;
  width: 750px;
  height: 380px;
  position: absolute;
  background: #fcfcfc 0% 0% no-repeat padding-box;
  border-radius: 24px;
  padding: 20px;
  transform: translate(-50%, -50%);
  overflow-x: auto;
}

.header {
  line-height: 1.6;
  font-size: 26px;
  font-weight: bold;
}
</style>